import { Cell, Grid, HeadingSection, InfoLabel } from 'bold-ui'
import { DateTime } from 'components/date'
import { UfSelectModel } from 'components/form'

interface RaniSaudeIndigenaSectionProps {
  unidadeFunai?: string
  livro?: number
  folha?: number
  cadastroUnico?: string
  dtEmissao?: string
  ufNascimento?: UfSelectModel
}

export const RaniSaudeIndigenaSection = (props: RaniSaudeIndigenaSectionProps) => {
  const { unidadeFunai, livro, folha, cadastroUnico, dtEmissao, ufNascimento } = props
  return (
    <HeadingSection level={2} title='RANI - Registro Administrativo de Nascimento Indígena'>
      <Grid wrap>
        <Cell size={4}>
          <InfoLabel title='Unidade da FUNAI'>{unidadeFunai?.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Livro'>{livro}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Folha'>{folha}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Nº Cadastro Único'>{cadastroUnico}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Data de Emissão'>
            <DateTime format='DD/MM/YYYY' value={dtEmissao} />
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='UF de Nascimento'>{ufNascimento?.nome.toUpperCase()}</InfoLabel>
        </Cell>
      </Grid>
    </HeadingSection>
  )
}
